import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../../header/header.component';
import { MessageMaintenanceListComponent } from '../message-maintenance-list/message-maintenance-list.component';
import { TuiAppearance, TuiButton, tuiDialog, TuiSurface } from '@taiga-ui/core';
import { TuiCardLarge, TuiHeader } from '@taiga-ui/layout';
import { MessageMaintenance } from '../../models/message-maintenance';
import { MessageMaintenanceService } from '../../services/message-maintenance.service';
import { Subscription } from 'rxjs';
import { MessageMaintenanceModalComponent } from '../message-maintenance-modal/message-maintenance-modal.component';

@Component({
  selector: 'app-message-maintenance-list-page',
  standalone: true,
  imports: [
    HeaderComponent,
    MessageMaintenanceListComponent,
    TuiCardLarge,
    TuiHeader,
    TuiSurface,
    TuiButton,
    TuiAppearance
  ],
  templateUrl: './message-maintenance-list-page.component.html',
  styleUrl: './message-maintenance-list-page.component.scss'
})
export class MessageMaintenanceListPageComponent implements OnInit {
  protected readonly messageMaintenanceList0: WritableSignal<Array<MessageMaintenance> | undefined> = signal(undefined);
  private modal: Subscription | undefined;

  private readonly messageMaintenanceService = inject(MessageMaintenanceService);

  private readonly dapMessageMaintenanceModal = tuiDialog(MessageMaintenanceModalComponent);

  ngOnInit(): void {
    this.messageMaintenanceService.pullList().subscribe({
      next: (messageMaintenanceList) => {
        this.messageMaintenanceList0.set(messageMaintenanceList);
      },
    });
  }

  openDialog(): void {
    this.modal = this.dapMessageMaintenanceModal({ messageMaintenance: undefined, onClose: () => this.closeDialog(), refreshList: () => this.refreshList() }).subscribe();
  }

  closeDialog(): void {
    this.modal?.unsubscribe();
  }

  refreshList = (): void => {
    this.messageMaintenanceService.pullList().subscribe({
      next: (messageMaintenanceList) => {
        this.messageMaintenanceList0.set(messageMaintenanceList);
      },
    });
  }

  destroyAll(): void {
    this.messageMaintenanceList0()?.forEach(messageMaintenance => {
      this.messageMaintenanceService.destroy(messageMaintenance.id).subscribe({
        next: () => {
          this.refreshList();
        },
      });
    });
  }
}
